import React, {Component} from 'react';

import './styles.scss';


class Box extends Component {

    render() {
        let currentYear= (new Date()).getFullYear();
        return (
            <div className={"box"}>
                <div className={"title"}>{this.props.title}</div>
                <div className={"box-row"}>
                    <div className={"value-year"}>
                        <div className={"year"}>{currentYear-1}</div>
                        {this.props.data1 &&
                        <div className={"value"} style={{color:this.props.color1? this.props.color1:'#585858'}}>
                            {this.props.data1}</div>}
                    </div>
                    <div className={"value-year"}>
                        <div className={"year"}>{currentYear}</div>
                        {this.props.data2 &&
                        <div className={"value"} style={{color:this.props.color2? this.props.color2:'#585858'}}>
                            {this.props.data2}</div>}
                    </div>
                </div>
            </div>
        );
    }
}


export default Box;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/table/components/box/Box.js